import { Tooltip } from '@ets/design-system';
import { useSelector, usePublicProfile } from '_common/hooks';
import { CSSProperties, useMemo } from 'react';
import { useIntl } from 'react-intl';
import styles from './TooltipWidget.module.scss';

type LockTooltipWidgetProps = {
  userId: string;
  testId: string;
  isPageLayout: boolean;
  offsets: Rect & { leftWithBounds?: number };
  widgetContainerLeftOffset: number;
};

const LockTooltipWidgetView = ({
  userId,
  testId,
  isPageLayout,
  offsets,
  widgetContainerLeftOffset,
}: LockTooltipWidgetProps) => {
  const intl = useIntl();
  const profile = usePublicProfile(userId);
  const zoom = useSelector((state) => state.editor.status.zoom);

  const style = useMemo<CSSProperties>(() => {
    const newStyle: CSSProperties = {};

    newStyle.top = offsets.top;
    if (isPageLayout) {
      newStyle.left = offsets.left - widgetContainerLeftOffset;
    } else {
      newStyle.left = offsets.left;
    }
    newStyle.width = offsets.width / zoom;

    return newStyle;
  }, []);

  return (
    <Tooltip
      testId={`${testId}-lock`}
      content={intl.formatMessage(
        { id: 'THIS_PARAGRAPH_BEING_EDITED_BY_USER' },
        { br: <br />, firstLastName: profile.name },
      )}
      open={true}
      placement="top"
    >
      <div style={style} className={styles.container}></div>
    </Tooltip>
  );
};

export default LockTooltipWidgetView;
